import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-tds-info-page',
  templateUrl: './tds-info-page.component.html',
  styleUrls: ['./tds-info-page.component.scss']
})
export class TdsInfoPageComponent implements OnInit {

  constructor(
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'tds-page');
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'tds-page');
  }

}
